/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { orgBudget, orgBudgetAssignedCostCenters } from './budget.i18n';
import {
  orgCostCenter,
  orgCostCenterAssignedBudgets,
  orgCostCenterBudgets,
} from './cost-center.i18n';
import { orgPurchaseLimit } from './permission.i18n';
import {
  orgUnit,
  orgUnitApprovers,
  orgUnitAddress,
  orgUnitAssignedApprovers,
  orgUnitAssignedRoles,
  orgUnitAssignedUsers,
  orgUnitChildren,
  orgUnitCostCenters,
  orgUnitUserRoles,
  orgUnitUsers,
} from './units.i18n';
import {
  orgUserGroup,
  orgUserGroupAssignedPermissions,
  orgUserGroupAssignedUsers,
  orgUserGroupPermissions,
  orgUserGroupUsers,
} from './user-group.i18n';
import {
  orgUser,
  orgUserApprovers,
  orgUserAssignedApprovers,
  orgUserAssignedPermissions,
  orgUserAssignedUserGroups,
  orgUserPermissions,
  orgUserUserGroups,
} from './user.i18n';

/**
 * The organization i18n labels provide generic labels for all organization sub features.
 * Once #7154 is in place, we can start adding specific i18n labels. The organization labels
 * will then serve as a backup.
 */

export const organization = {
  organization: {
    enabled: 'Ativo',
    disabled: 'Desactivado',

    enable: 'Habilitar',
    disable: 'Desabilitar',

    name: 'Nome',
    code: 'Código',

    fato: 'fato',

    cancel: 'Cancelar',

    add: 'Adicionar',
    manageUsers: 'Gerenciar usuários',
    create: 'Criar {{{name}}',
    edit: 'Editar',
    save: 'Salvar {{{name}}',
    delete: 'Apagar',

    assign: 'Gerir',

    active: 'Ativo',
    status: 'Estado',
    details: 'Detalhes',

    messages: {
      emptyList: 'A lista está vazia',
    },
    userRoles: {
      b2bcustomergroup: 'Cliente',
      b2bapprovergroup: 'Aprovador',
      b2bmanagergroup: 'Gestor',
      b2badmingroup: 'Admin',
    },

    userRights: {
      unitorderviewergroup: 'Exibir pedidos em nível de unidade',
    },

    breadcrumb: 'Organização',

    notification: {
      noSufficientPermissions: 'Não há permissões suficientes para acessar esta página',
      notExist: 'Este item não existe',
      disabled: 'Não é possível editar um item desativado',
    },

    confirmation: {
      cancel: 'CANCELAR',
      confirm: 'CONFIRMAR',
      disable: 'DESABILITAR',
      delete: 'APAGAR',
    },

    httpHandlers: {
      conflict: {
        budget: 'A citação com o código {{ code }} já existe.',
        costCenter: 'O centro de custo com o código {{ code }} já existe.',
        unit: 'A UO com uid {{ code }} já existe.',
        user: 'O usuário com e-mail {{ code }}já existe',
        userGroup: 'O grupo de usuários com id {{ code }} já existe',
        permission: 'A permissão de aprovação com o código {{ code }} já existe.',
        unknown: 'Falha na validação do servidor.',
      },
    },
    information: 'Informação',
  },

  // sub feature labels are added below
  orgCostCenter,
  orgCostCenterBudgets,
  orgCostCenterAssignedBudgets,
  orgBudget,
  orgBudgetAssignedCostCenters,
  orgUnit,
  orgUnitChildren,
  orgUnitApprovers,
  orgUnitAssignedApprovers,
  orgUnitAssignedRoles,
  orgUnitUsers,
  orgUnitUserRoles,
  orgUnitAssignedUsers,
  orgUnitCostCenters,
  orgUnitAddress,

  orgUserGroup,
  orgUserGroupUsers,
  orgUserGroupAssignedUsers,
  orgUserGroupPermissions,
  orgUserGroupAssignedPermissions,
  orgUser,
  orgUserUserGroups,
  orgUserAssignedUserGroups,
  orgUserApprovers,
  orgUserAssignedApprovers,
  orgUserPermissions,
  orgUserAssignedPermissions,
  orgPurchaseLimit,
};
